import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { DateTimeAdapter } from 'ng-pick-datetime';
import { AuthenticationService } from './services/authentication.service';
import { PopupService } from './services/popup.service';
import { UserSessionService } from './services/usersession.service';
import { SpinnerComponent } from './views/layout/spinnercomponent/spinner.component';
// @HostListener("window:onbeforeunload", ["$event"])
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

export class AppComponent implements OnInit {
  title = 'PPC';
  spinnerComponent = SpinnerComponent;
  returnUrl: any;
  popup: boolean;
  popupText: string;
  popupColor: string;

  public validinput:RegExp = /^[^\s]+(\s+[^\s]+)*$/;
  constructor(dateTimeAdapter: DateTimeAdapter<any>,
    private router: Router,
    private sessionService: UserSessionService,
    private popupService: PopupService,
    private route: ActivatedRoute,) {
    dateTimeAdapter.setLocale('en-in');
  }

  ngOnInit(): void {
    this.popupService.popupEmitter.subscribe(popupState => {
      this.popup = popupState.isOpen;
      this.popupText = popupState.text;
      this.popupColor = popupState.color;
    });
    this.router.events.subscribe((e) => {
      if (e instanceof NavigationEnd) {
        if (e.url.startsWith('/manageclient/')
      ) {
          document.body.classList.add('removeglobalfilter');
        } else {
          document.body.classList.remove('removeglobalfilter');
        }
      }
    });

    if (this.router.url !== '/dashboard') {
      this.router.navigate(['dashboard']);
    } else {
      this.router.navigate(['dashboard']);
    }
    
  }

  clearAllData() {
  }

}
